import ProgramPage from '../components/ProgramPage';
import React from 'react';

const Program: React.FC = () => {
  return <ProgramPage/>
}

export default Program;